/**
 * Chrome ignores autocomplete="off" on fields it thinks are address/country.
 * A recognised non-address token on the native <input> wins over heuristics.
 */
function apply(el) {
  const input =
    el.tagName === "INPUT" || el.tagName === "TEXTAREA"
      ? el
      : el.querySelector("input:not([type=hidden]), textarea");
  if (input) {
    input.setAttribute("autocomplete", "one-time-code");
  }
}

export default {
  inserted: apply,
  componentUpdated: apply,
};
